import { useLocale } from "../i18n";
import type { OwnedSubscription } from "./ownedSubscriptions";

export function SubscriptionAvailability({ item }: { item: OwnedSubscription }) {
  const { w } = useLocale();
  return <p className="entry-store-note">{item.operationalStatus === "NOT_READY"
    ? w("اشتراكك محفوظ، لكن الخدمة غير جاهزة للتشغيل بعد. تواصل مع إدارة مزن لاستكمال إعداد الخدمة.", "Your subscription is recorded, but the service is not ready to operate yet. Contact MZN administration to complete its setup.")
    : w("اشتراك المنشأة محفوظ. إدارة الخدمة أو استعراضها غير متاحين لهذا الحساب وفق صلاحياته الحالية.", "The organization’s subscription is recorded. Managing or viewing this service is not available to this account under its current permissions.")}</p>;
}
